var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  account: JSON.parse(localStorage.getItem('accountData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: 'https://my.cliniqueadmin.com/',
  baseApiUrl: 'https://my.cliniqueadmin.com/api/'
};
export default Common;